import React from "react";
import "./btn-blanc.scss";
import PropTypes from "prop-types";

/**
 * Permet d'afficher les boutons blancs
 */
const BtnBlanc = (props) => {
  return (
    <button className="btn-blanc" onClick={props.btnAction} type={props.action}>
      {props.btnIcone}
      {props.btnTexte}
      {props.children}
    </button>
  );
};

BtnBlanc.propTypes = {
  btnAction: PropTypes.func,
  btnTexte: PropTypes.string,
  children: PropTypes.any,
  btnIcone: PropTypes.any,
  action: PropTypes.string,
};

BtnBlanc.defaultProps = {
  action: "submit",
};

export default BtnBlanc;
